





















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";

import {
  pagination,
  loadingCatch,
  loading,
  SearchbarControl,
  FormVaildateToOut,
  IsMore,
} from "@root/lib/decorator";
import ActivityCycle from "./components/ActivityCycle.vue";
import { numZp, money } from "@root/lib/formRules.ts";
import GtUploadFile from "@/components/custom/uploadFile/index.vue";
import selectMore from "./components/children/selectMore.vue";
import orgImportTable from "./components/children/orgImportTable.vue";
import UploadBlock from "./components/children/UploadBlock.vue";
import TagSelect from "./components/TagSelect.vue";
import RemoteSelect from "@/components/custom/RemoteSelect.vue";
import ProductPickerDialog from "./components/ProductPickerDialog.vue";
import ProductImportDialog from "./components/ProductImportDialog.vue";
import TableHeaderSearch from "./components/children/TableHeaderSearch.vue";
import CustomTableScrollWrap from "@/components/custom/CustomTableScrollWrap/index.vue";

const defaultImgPlaceholder = require("../../assets/image/wt-table-empty.png");
const common = namespace("common");
const root = namespace("root");
const wt = namespace("wt");

@Component({
  components: {
    TagSelect,
    GtUploadFile,
    selectMore,
    orgImportTable,
    UploadBlock,
    ActivityCycle,
    RemoteSelect,
    TableHeaderSearch,
    CustomTableScrollWrap,
    ProductImportDialog,
    ProductPickerDialog,
  },
  data() {
    return {
      numZp,
      numMoney: money,
    };
  },
})
@pagination("getData", {
  pageSize: 50,
})
@SearchbarControl()
@loading()
@IsMore(true)
// @FormVaildateToOut("form") // TODO: 通用的装饰器需要改进通用性
// @FormVaildateToOut("batchForm")
// @FormVaildateToOut("cycleForm")
// 创建，查看，编辑，复制 0,1,2,3
export default class WtActivityEdit extends Vue {
  @common.State wtBrandTagsOptions;
  @root.State ddCodes;

  @common.Action queryDataDictionaryListLang;
  @wt.Action createPriceActivity;
  @wt.Action updatePriceActivity;
  @wt.Action queryPriceActivity;
  @wt.Action queryActivitySku;
  @wt.Action checkPriceActivity;
  @wt.Action queryBaseStorePage;
  @wt.Action changeActivityStatus;
  @root.Action getSystemValue;
  @common.Action getDataValue;

  private isGiTi = false;
  private isKoneVersion2 = true;
  private isShowOtherCondition = false;
  private isShowFrequency = false;

  private acDescInfo = "建议尺寸：宽 750px，高 300px"; // 活动说明图
  private acEntryInfo = "建议尺寸：宽 686px，高 240px"; // 活动入口图

  private defaultImgPlaceholder = defaultImgPlaceholder;
  private ddCodeChannel = "CHANNEL";
  private ddCodePayment = "PAYMENT_METHOD";
  private tagOptionsList = [];
  private formAcTagSearch = [];
  private form = {
    acName: "",
    acTimedate: [],
    // acTimedate: ["2020-12-12 8:00:00", "2020-12-24 10:00:00"],
    acFrequency: "0",
    acRange: "0",
    acTagSearch: null,
    acIsPremium: "0",
    acPriceTop: "", // String
    acPriceBottom: "", // String
    preTime: "", // 预热时间
    coolTime: "", // 冷却时间
    backgroundImage: "", // 背景图片
    entranceImage: "", // 入口背景图
    displayName: "", // 显示名称
    activityLabel: "", // 标签
    memo: "", // 简述
    desc: "", // 描述
    otherSaleChannel: "", // 销售渠道 string by ","
    otherPayType: "", // 支付方式 string by ","
    skuList: [], // 名字涉及到校验，skuList
  };
  private formAcRangeType = "0";
  private cycleForm = {
    cycleTime: ["10:00:00", "23:59:59"],
  };
  private cycleExpresstion = "";
  // 批量设置
  private batchForm = {
    bAcPrice: "",
    bStock: "",
    bLimit: "",
    bLimitAll: "",
    bStartNum: "",
  };
  private payOnlineForm = {
    onlinePayType: "0", //此字段后端接口已经不认了，只是为了防止非空验证给个传值
  };
  private pageTitle = "创建新活动"; // 编辑新活动

  private batchSetVisible = false;
  private inventoryBatchSetVisible = false;
  private maxPerUserBatchSetVisible = false;
  private priceBatchSetVisible = false;
  private productImportVisible = false;
  private selectProductVisible = false;
  private showCycleVisible = false;

  private tableLoading = false;
  private isSaveLoading = false;
  private loading = false;
  private checkDupLoading = false;
  private selectTagLoading = false;

  private tagOptions = [
    {
      value: "",
      label: "全部",
    },
  ];

  private storeSelectedList = [];
  private allSelectTreeDatas = [];

  private tableSelectionList = [];
  private hasTableSelectedAll = false;
  private activitySkuListTmp = [];
  private duplicateSkuList = [];

  private pageData = {};
  private templateUrl = "";
  private selectedSearchStr = "";

  get filterFormSkuListComputed() {
    const { selectedSearchStr } = this;
    return this.form.skuList.filter(
      (data) =>
        !selectedSearchStr ||
        (data.productName + data.productCode + data.skuName + data.skuCode)
          .toLowerCase()
          .includes(selectedSearchStr.toLowerCase()),
    );
  }

  get canAddProduct() {
    // 添加商品 活动日期和门店标签已选的情况下，才可以添加商品。
    // return !(this.form.acTimedate && this.form.acTimedate.length > 0);
    return !(
      this.form.acTimedate &&
      this.form.acTimedate.length > 0 &&
      ((parseInt(this.form.acRange) !== 0 && this.form.acTagSearch) ||
        parseInt(this.form.acRange) === 0)
    );
  }

  get routerPageStatus() {
    // 创建，查看，编辑，复制 0,1,2,3
    return (this.$route.query.pageStatus || "0") as any;
  }
  get routeType() {
    const { path } = this.$route;
    const type = ~String(path).toLowerCase().indexOf("pcr") ? "pcr" : "tbr";
    return String(type).toLowerCase();
  }
  get isCreateStatus() {
    return ["0", "3"].includes(String(this.routerPageStatus));
  }
  get isEditStatus() {
    return ["2"].includes(String(this.routerPageStatus));
  }
  get activityStatus() {
    return String(parseInt((this.pageData as any).activityStatus));
  }
  get isUpdatePublish() {
    return this.isEditStatus && ["2", "3"].includes(this.activityStatus);
  }
  get canImmediatePublish() {
    // 创建
    if (this.isCreateStatus) {
      return true;
    }
    // 编辑
    if (this.isEditStatus) {
      return ["1"].includes(this.activityStatus);
    }
    // 查看
    return false;
  }

  get isSkuStatus() {
    // skuList里有值
    return ["2", "3"].includes(String(this.routerPageStatus));
  }
  get unTotalInventory() {
    // 显示剩余库存
    return this.routerPageStatus === "1" || this.routerPageStatus === "2";
  }
  get routerCode() {
    return (this.$route.query.code || "") as any;
  }
  get readonly() {
    return this.routerPageStatus === `1` || this.loading;
  }
  get userInfo() {
    // 注意： k-one在这里请求时的userCode是本地的orgCode
    return JSON.parse(localStorage.getItem("userInfo") || null);
  }
  get changePriceStr() {
    return "请输入正数";
  }
  get restInventoryTxt() {
    return "投放资源";
  }
  get totalInventoryTxt() {
    return "总资源";
  }
  get maxPerUserTxt() {
    return "单店限购";
  }
  async handleImportConfirmSelect(importDataList) {
    (this.$refs.tableScrollWrapRef as any).toggleInit();
    this.handleConfirmSelect(importDataList, true);
    this.productImportVisible = false;
  }
  /**
   * 弹窗内逻辑
   * hasSalePrice：因为批量导入商品，有活动价，但是选择商品没有活动价
   */
  async handleConfirmSelect(selecteds, hasSalePrice = false) {
    const { fPickerData, getUniqueNewList } = this;
    selecteds = fPickerData(selecteds);
    selecteds = getUniqueNewList(selecteds);
    // 格式化所需要的商品
    const selectData = selecteds.map(
      (
        {
          mediaLink,
          mobileMediaLink,
          orgCode,
          productCode,
          productName,
          skuCode = "",
          skuName,
          salePrice = null,
          skuInventory = null,
          maxPerUser = null,
          productPrice,
        },
        index,
      ) => {
        const propsObject = {
          mediaLink: mediaLink || mobileMediaLink,
          orgCode,
          productCode,
          productName,
          skuCode: skuCode || productCode,
          skuName: skuName || productName,
          skuInventory,
          maxPerUser,
          productPrice: salePrice,
          tIndex: productCode + index,
        };
        if (hasSalePrice) {
          return { ...propsObject, salePrice };
        } else {
          return { ...propsObject, salePrice: null };
        }
      },
    );
    let hasExistList = JSON.parse(JSON.stringify(this.form.skuList)) || [];
    const hadSelected = JSON.parse(JSON.stringify(this.tableSelectionList));
    if (hasExistList.length > 0) {
      const orgSkuId = (item) => {
        return item && item.productCode;
      };
      // TODO: 优化新代码复杂度
      const newReplaceDatas = hasExistList.map((item) => {
        // 新增数据替换原有数据
        const isDupObj = selectData.find(
          (el) => orgSkuId(el) === orgSkuId(item),
        );
        return isDupObj || item;
      });
      const restDatas = selectData.filter(
        (el) =>
          !newReplaceDatas.map((item) => orgSkuId(item)).includes(orgSkuId(el)),
      );
      this.form.skuList = newReplaceDatas.concat(restDatas);
      // 勾选已经存在的数据
      const hadSelectedIndexs = hadSelected.map((item) => item && item.tIndex);
      this.form.skuList.forEach((row) => {
        if (hadSelectedIndexs.includes(row && row.tIndex)) {
          this.$nextTick(() => {
            (this.$refs.tableProduct as any).toggleRowSelection(row, true);
          });
        }
      });
    } else {
      this.form.skuList = selectData;
    }
    // 选完确认后关闭弹窗
    this.selectProductVisible = false;
    await this.checkDupliteActivitySkus();
  }
  /**
   * 批量设置
   */
  handleConfirmBatchSet() {
    let tableSelectionList = this.tableSelectionList;
    if (this.hasTableSelectedAll) {
      tableSelectionList = this.form.skuList;
    }
    if (tableSelectionList.length === 0) return;
    (this.$refs.batchForm as any).validate((valid) => {
      if (valid) {
        const selectedListIndexs = tableSelectionList.map(
          (item) => item && item.tIndex,
        );
        this.form.skuList.forEach((row) => {
          if (selectedListIndexs.includes(row && row.tIndex)) {
            const {
              bAcPrice,
              bStock, // 剩余库存
              bLimit,
              bLimitAll,
              bStartNum,
            } = this.batchForm;
            const {
              salePrice,
              skuInventory,
              eachPerUser,
              maxPerUser,
              initUser,
            } = row;
            this.$set(row, "salePrice", bAcPrice || salePrice);
            this.$set(row, "skuInventory", bStock || skuInventory);
            this.$set(row, "eachPerUser", bLimit || eachPerUser);
            this.$set(row, "maxPerUser", bLimitAll || maxPerUser);
            this.$set(row, "initUser", bStartNum || initUser);
          }
        });
        // 关闭弹窗
        this.batchSetVisible = false;
        this.inventoryBatchSetVisible = false;
        this.maxPerUserBatchSetVisible = false;
        this.priceBatchSetVisible = false;
      } else {
        return false;
      }
    });
  }
  async handelDeleteList() {
    if (this.tableSelectionList.length === 0) {
      this.$message.warning("请选择商品");
      return;
    }
    await this.$confirm("商品批量删除请谨慎操作，确定删除？", "", {
      confirmButtonText: "确定",
      showCancelButton: true,
      type: "warning",
    });
    const { hasTableSelectedAll } = this;
    if (hasTableSelectedAll) {
      this.form.skuList = [];
    } else {
      const selectedList = this.tableSelectionList;
      const tIndexs = selectedList.map((item) => item && item.tIndex);
      this.form.skuList = this.form.skuList.filter(
        (item) => !tIndexs.includes(item && item.tIndex),
      );
    }
    this.$nextTick(() => {
      this.$message.success("删除成功");
    });
  }
  /**
   * 表格在load
   */
  handleTableLoad() {
    const { hasTableSelectedAll } = this;
    const selecteAll = () => {
      this.$nextTick(() => {
        (this.$refs.tableProduct as any).toggleAllSelection();
      });
    };
    const clearSelect = () => {
      this.$nextTick(() => {
        (this.$refs.tableProduct as any).clearSelection();
      });
    };
    if (hasTableSelectedAll) {
      selecteAll();
    } else {
      // clearSelect();
      // FIXME：这个地方有问题，不应该设置全部为全选，半勾选状态的时候。应该记录没有选中的数据。
      selecteAll();
    }
  }
  async handleChangeCycleDate() {
    await (this.$refs.cycleForm as any).validate((valid) => {
      if (valid) {
        this.showCycleVisible = false;
        console.log("submit");
      } else {
        console.log("error submit!!");
        return false;
      }
    });
    // 成功之后关闭弹窗
  }

  async saveEdit(saveType = "") {
    // 提交数据
    if (this.isShowFrequency) {
      if (!this.cycleExpresstion && this.form.acFrequency === `1`) {
        this.$message.error("请选择周期");
        return;
      }
    }
    let validForms = [];
    const validForm = (formName) => {
      let result = new Promise((resolve, reject) => {
        (this.$refs[formName] as any).validate((valid, callbackObj) => {
          if (valid) {
            resolve(valid);
          } else {
            const cbInfo =
              Object.keys(callbackObj).length > 0
                ? JSON.stringify(callbackObj)
                : "valid Failed";
            reject(cbInfo);
          }
        });
      });
      validForms.push(result);
    };
    let needValidForms = [];
    let defaultVerifyForms = [
      "tagForm",
      "mainForm",
      "tableFormRef",
      // "payOnlineFormRef"
    ];
    if (this.showFinanceInfo) {
      defaultVerifyForms = [
        "tagForm",
        "mainForm",
        "tableFormRef",
        // "payOnlineFormRef"
      ];
    }
    if (this.isShowFrequency) {
      defaultVerifyForms.push("mainCycleForm");
    }
    if (this.isGiTi) {
      needValidForms = ["priceForm", ...defaultVerifyForms];
    } else {
      needValidForms = defaultVerifyForms;
    }
    // 保存草稿，不需要填写必填。立即发布，需填写必填
    // 非立即发布,且不是更新发布，就是保存草稿
    if (!saveType && !this.isUpdatePublish) {
      needValidForms = [];
    }
    needValidForms.forEach((item) => {
      validForm(item);
    });
    Promise.all(validForms)
      .then(async () => {
        const res = await this.saveRequestData(saveType);
        if (!res) {
          return false;
        }
        this.$message.success("成功");
        setTimeout(async () => {
          await this.goRoutePage();
        }, 500);
      })
      .catch((err) => {
        //验证失败 提示reject失败状态的值
        try {
          const errObj = JSON.parse(err);
          // 找到了表格里有报错信息
          if (~String(Object.keys(errObj)).indexOf("skuList")) {
            const errMsg = Object.values(errObj)[0][0].message || "error";
            this.$message.error(errMsg);
          } else {
            this.$message.error("请检查必填项");
          }
        } catch (error) {
          this.$message.error("请检查必填项");
        }
      });
  }

  async goRoutePage() {
    await this.$router.push({
      path: `/wtActivity/${this.routeType}`,
      params: { type: this.routeType },
    });
  }

  async saveRequestData(saveType) {
    // 创建，查看，编辑，复制 0,1,2,3
    const { isCreateStatus, isEditStatus } = this;
    // 活动名称
    const requestData = this.getRequestData();
    this.isSaveLoading = true;
    try {
      if (this.form.skuList.length > 0) {
        const res = await this.checkDupliteActivitySkus(false);
        if (!res) {
          return false;
        }
      }
      // 创建，查看，编辑，复制 0,1,2,3
      let createResponse = null;
      if (isCreateStatus) {
        createResponse = await this.createPriceActivity(requestData);
      }
      if (isEditStatus) {
        // 如果是编辑状态，skuList要过滤已经查重过的旧数据
        createResponse = await this.updatePriceActivity({
          ...requestData,
          activityCode: this.routerCode,
        });
      }
      if (parseInt(saveType) === 2 || this.isUpdatePublish) {
        // 立即发布或者更新发布需要吧状态改为02
        const {
          data: {
            status: { code },
          },
        } = createResponse;
        await this.changeActivityStatus({
          activityCode: code,
          status: "02", // 02 表示发布
        });
      }
    } catch (error) {
      console.error(error);
      return false;
    } finally {
      this.isSaveLoading = false;
    }
    return true;
  }

  async getPageStatusData() {
    // 默认创建
    const pageStatus = this.routerPageStatus;
    const code = this.routerCode;
    if (pageStatus === "0" || !code) return;
    let getSkuList;
    try {
      const list = await this.getPriceData(code);
      getSkuList = await this.getData();
      // skuList 统一添加tIndex
      const fNull = (prop) => {
        return prop === 0 ? null : prop || null;
      };
      getSkuList = getSkuList.map(
        ({ maxPerUser, eachPerUser, initUser, ...item }, index) => {
          // maxPerUser，eachPerUser，initUser
          return {
            maxPerUser: fNull(maxPerUser),
            eachPerUser: fNull(eachPerUser),
            initUser: fNull(initUser),
            ...item,
            tIndex: item.skuCode + index,
          };
        },
      );
      this.activitySkuListTmp = getSkuList;
      if (list && list.length > 0) {
        this.pageData = list[0];
      } else {
        return;
      }
    } catch (error) {
      console.error(error);
      return;
    }
    const titleMap = {
      "0": "创建新活动",
      "1": "活动详情",
      "2": "编辑活动",
      "3": "创建新活动",
    };
    this.pageTitle = titleMap[pageStatus];
    // 赋值所有数据
    const {
      activityName,
      activityBegin,
      activityEnd,
      isCycleActivity,
      timeExpression,
      activitytimeBegin,
      activitytimeEnd,
      isPremium,
      premiumRangStart,
      premiumRangEnd,
      qualificationsExpression,
      preheatTime, // 预热时间
      coolingTime, // 冷却时间
      backgroundImage, // 背景图片
      entranceImage, // 入口图片
      displayName, // 显示名称
      activityLabel, // 标签
      activityRemark, // 简述
      activityDescribe, // 描述
      qualificationDomains, // 其他条件
      activitySkuInput,
    } = this.pageData as any;
    // 非复制的时候,所有数据正常带入
    // 复制时只带入部分数据
    const dfTagSearch = (expression) => {
      return this.dfActivityExpresstion(expression, (type) => {
        this.formAcRangeType = type === 4 ? "1" : "0";
      });
    };
    const dfRangeType = (expression) => {
      return String(this.activityExpresstionType(expression));
    };
    if (this.routerPageStatus === "3") {
      this.form = {
        acName: "",
        acTimedate: [],
        acFrequency: "0",
        acIsPremium: "0",
        acRange: dfRangeType(qualificationsExpression),
        acTagSearch: dfTagSearch(qualificationsExpression),
        acPriceTop: "", // 价格调控
        acPriceBottom: "",
        preTime: "", // 预热时间
        coolTime: "", // 冷却时间
        backgroundImage: "", // 背景图片
        entranceImage: "", // 入口图片
        displayName: "", // 显示名称
        activityLabel: "", // 标签
        memo: "", // 简述
        desc: "", // 描述
        otherSaleChannel: "",
        otherPayType: "",
        skuList: getSkuList.map(
          ({
            skuQuota,
            skuInventory,
            eachPerUser,
            maxPerUser,
            initUser,
            salePrice,
            ...sItem
          }) => {
            return {
              salePrice: "",
              skuQuota: "",
              skuInventory: "",
              eachPerUser: "",
              maxPerUser: "",
              initUser: "",
              ...sItem,
            };
          },
        ), // 选中的商品
      };
      this.cycleForm = {
        cycleTime: ["10:00:00", "23:59:59"],
      };
    } else {
      this.form = {
        acName: activityName,
        acTimedate: this.fDateLine(activityBegin)
          ? [this.fDateLine(activityBegin), this.fDateLine(activityEnd)]
          : [],
        acFrequency: String(+isCycleActivity),
        acIsPremium: String(+isPremium),
        acRange: dfRangeType(qualificationsExpression),
        acTagSearch: dfTagSearch(qualificationsExpression),
        acPriceTop: !isNaN(parseInt(premiumRangEnd)) ? premiumRangEnd : "",
        acPriceBottom: !isNaN(parseInt(premiumRangStart))
          ? premiumRangStart
          : "",
        preTime: preheatTime, // 预热时间
        coolTime: coolingTime, // 冷却时间
        backgroundImage, // 背景图片
        entranceImage, // 入口图片
        displayName, // 显示名称
        activityLabel: activityLabel, // 标签
        memo: activityRemark, // 简述
        desc: activityDescribe, // 描述
        otherSaleChannel: this.dfOtherExpression(
          this.ddCodeChannel,
          qualificationDomains,
        ),
        otherPayType: this.dfOtherExpression(
          this.ddCodePayment,
          qualificationDomains,
        ),
        skuList: getSkuList, // 通过单独的
      };
      this.cycleForm = {
        cycleTime: [activitytimeBegin, activitytimeEnd],
      };
    }
    // 获取支付状态的值，来更新之后的值
    let { otherPayType } = this.form;
    if (otherPayType) {
      const payTypeListLen = otherPayType.length;
      const ddListLen = this.ddCodes.PAYMENT_METHOD.length;
      // 仅支持线上支付：是、否“。选择”是“，则该活动所涉及的商品只支持线上支付；选择”否“，则该活动所涉及的商品线上线下两种支付方式都支持
      this.payOnlineForm.onlinePayType =
        payTypeListLen === ddListLen ? "0" : "1";
    }
  }

  async checkDupliteActivitySkus(isWarn = false) {
    // 检查是否有重复的商品
    // 判断是否重复，更新时候需要引入不检查已有数据的值
    this.checkDupLoading = true;
    const requestData = this.getRequestData();
    const {
      activitySkuInput: skuList,
      orgCode,
      activityName,
      isPremium,
      premiumRangStart,
      premiumRangEnd,
      preheatTime, // 预热时间
      coolingTime, // 冷却时间
      backgroundImage, // 背景图片
      entranceImage, // 入口图片
      displayName, // 显示名称
      activityLabel, // 标签
      activityRemark, // 简述
      activityDescribe, // 描述
      activityType, // 查询活动类型
      qualificationInputs, // 其他条件
      paymentMethod, // 支付方式
      ...item
    } = requestData;
    const skuListSkuStrs = skuList.map((item) => item && item.skuCode);
    let duplicateSkusList = [];
    if (skuListSkuStrs && skuListSkuStrs.length > 0) {
      let { list: duplicateSkus = [] } = await this.checkPriceActivity({
        activityCode: this.routerCode,
        skuList: skuListSkuStrs,
        ...item,
      });
      this.duplicateSkuList = duplicateSkus;
      duplicateSkusList = duplicateSkus.map((item) => item && item.skuCode);
    }
    if (duplicateSkusList && duplicateSkusList.length > 0) {
      let hasSkus = [];
      // 只有编辑状态，的时候存储第一次进来时已有数据skuCode
      if (this.isEditStatus) {
        hasSkus = this.activitySkuListTmp
          .map((item) => item && item.skuCode)
          .filter(Boolean);
      }
      this.form.skuList.forEach((item) => {
        if (
          duplicateSkusList.includes(item.skuCode) &&
          !hasSkus.includes(item.skuCode)
        ) {
          // 数组增加了属性,传递的时候,不需要刻意去除,引用类型不会改变原数组
          this.$set(item, "repeat", true);
        } else {
          this.$set(item, "repeat", false);
        }
      });
      if (isWarn) {
        //- 若有重复参加活动的商品，商品选择器点击「确定」后，弹窗提示
        // this.warnRepeat();
        try {
          await this.warnRepeat();
        } catch (error) {
          this.checkDupLoading = false;
          console.log("refuse");
          return false;
        }
      }
    }
    this.checkDupLoading = false;
    return true;
  }
  // @loadingCatch
  async getData() {
    const code = (this.$route.query.code || "") as any;
    if (!code) return;
    // skuList
    let { pageSize, currentPage: pageNum } = this as any;

    if (parseInt(this.routerPageStatus) !== 1) {
      pageSize = 1000;
    }
    const pageInput = {
      pageSize,
      pageNum,
    };
    try {
      const { list, total } = await this.queryActivitySku({
        priceActivityCode: code,
        pageInput,
      });
      if (parseInt(this.routerPageStatus) === 1) {
        this.form.skuList = list;
      }
      (this as any).total = total;
      return list;
    } catch (error) {
      (this as any).total = 0;
      return [];
    }
  }

  async getPriceData(code) {
    this.tableLoading = true;
    try {
      let input = {
        activityCode: code,
      };
      const { list } = await this.queryPriceActivity({
        input,
        pageInput: {
          pageSize: 100,
          pageNum: 1,
        },
      });
      return list;
    } catch (error) {
      console.log(error);
      return [];
    } finally {
      this.tableLoading = false;
    }
  }
  async getTagOptions() {
    this.tagOptions = await this.queryDataDictionaryListLang({
      statePath: "wtBrandTagsOptions",
      ddCode: "STORE_TAG",
    });
  }
  async getTemplateUrl() {
    const { valueValue } = await this.getSystemValue({
      valueCode: "WT_ACTIVITY_TEMPLATE_URL",
    });
    this.templateUrl = valueValue;
  }

  async warnRepeat() {
    /**
     * 判断是否是Giti还是K-one，显示不同的提示：
     * K1：选择的商品中包含Giti已参加活动的商品，发布后将取Giti活动的价格
     * Giti/K1：选择的商品中包含已参加活动的商品，发布后将取本次活动的价格
     */
    const { duplicateSkuList, userInfo } = this;
    let warnTypeMsg = "";
    const warnTypeMap = {
      0: "选择的商品中包含Giti已参加活动的商品，发布后将取Giti活动的价格", // 用户为k1，商品中含有giti
      1: "选择的商品中包含已参加活动的商品，发布后将取本次活动的价格", // 用户为giti，商品中含有giti
      2: "选择的商品中包含已参加活动的商品，发布后将取本次活动的价格", // 用户为k1，商品中不含有giti
    };

    const isLoginedK1 = !["root", "default"].includes(
      userInfo && userInfo.orgCode,
    );
    // 是否含有giti,orgCode字段还不一定有
    const hasDuplicatGitiSkus = duplicateSkuList.some((el) =>
      ["root", "default"].includes(el && el.orgCode),
    );
    // k1用户
    if (isLoginedK1 && hasDuplicatGitiSkus) {
      warnTypeMsg = warnTypeMap[0];
    } else {
      warnTypeMsg = warnTypeMap[1];
    }

    return await this.$confirm(warnTypeMsg, "", {
      confirmButtonText: "知道了",
      showCancelButton: false,
      type: "warning",
    });
  }
  handleBatchSetSingle(type) {
    if (type === "4") {
      this.productImportVisible = true;
      return;
    }
    if (this.tableSelectionList.length === 0) {
      this.$message.warning("请选择商品");
      return;
    }
    const map = {
      "1": () => (this.inventoryBatchSetVisible = true),
      "2": () => (this.maxPerUserBatchSetVisible = true),
      "3": () => (this.priceBatchSetVisible = true),
    };
    if (type) map[type]();
    // reset form
    this.$nextTick(() => {
      (this.$refs.batchForm as any).resetFields();
    });
    this.batchForm = {
      bAcPrice: "",
      bStock: "",
      bLimit: "",
      bLimitAll: "",
      bStartNum: "",
    };
  }

  handleBatchSet() {
    if (this.tableSelectionList.length === 0) {
      this.$message.warning("请选择商品");
      return;
    }
    this.batchSetVisible = true;
    // reset form
    this.$nextTick(() => {
      (this.$refs.batchForm as any).resetFields();
    });
    this.batchForm = {
      bAcPrice: "",
      bStock: "",
      bLimit: "",
      bLimitAll: "",
      bStartNum: "",
    };
  }

  handleSelectionChange(list) {
    // 门店
    this.tableSelectionList = list;
    this.hasSelectedAll();
  }
  /**
   * 判断是否是选中了全部
   * 1. 点击全部的checkbox不可靠
   * 2. load的时候要看
   */
  hasSelectedAll() {
    try {
      this.$nextTick(() => {
        const isAllSelected = this.$refs.tableProduct["store"]["states"][
          "isAllSelected"
        ];
        this.hasTableSelectedAll = isAllSelected;
      });
    } catch (error) {
      console.log(error);
    }
  }
  handleAcRange() {
    if (this.form.acRange !== `0`) {
      if (this.form.acRange === "2") {
        this.form.acTagSearch = "";
      } else {
        this.form.acTagSearch = null;
      }
    }
  }
  handleSelectTreeInited(val) {
    this.allSelectTreeDatas = val;
    const { qualificationsExpression } = this.pageData as any;
    this.dfActivityExpresstion(qualificationsExpression);
  }

  handleCycleComponent(valObj) {
    const { timeRange, expresstion } = valObj;
    this.cycleForm.cycleTime = timeRange;
    // this.form.acFrequency
    this.cycleExpresstion = expresstion;
    // console.log(val, "handleCycleComponent");
  }

  get pickerOptions() {
    const oneDay = 3600 * 24 * 1000;
    return {
      disabledDate(time) {
        return time.getTime() < Date.now() - oneDay;
      },
    };
  }
  get batchRules() {
    const propList = ["bAcPrice"];
    return this.fRules(propList);
  }
  get rangRules() {
    const propList = ["acTagSearch"];
    const tipStr =
      this.formAcRangeType === "0" ? "请选择门店编码" : "请导入门店编码";
    return this.fRules(propList, tipStr);
  }
  get mainRules() {
    let propList = [];
    if (this.isGiTi) {
      propList = [
        "acName",
        "acTimedate",
        "acFrequency",
        "acTagSearch",
        "acPriceTop",
        "acPriceBottom",
      ];
    } else {
      propList = ["acName", "acTimedate", "acFrequency", "acTagSearch"];
    }
    return this.fRules(propList);
  }

  get currentOrgCode() {
    const globalOrginfo = localStorage.getItem("orgInfo") || "{}";
    const { orgCode = "default" } = JSON.parse(globalOrginfo);
    return orgCode;
  }

  @Watch("form.acTagSearch") handleTag(val) {
    if (Array.isArray(val)) {
      this.formAcTagSearch = val;
    }
  }
  getRequestData() {
    const {
      acName,
      acIsPremium,
      acTimedate,
      acFrequency,
      acPriceTop,
      preTime,
      coolTime,
      backgroundImage,
      entranceImage,
      displayName,
      activityLabel,
      memo,
      desc,
      acPriceBottom,
      otherPayType,
    } = this.form;
    const { onlinePayType } = this.payOnlineForm;
    /* FIXME: 这里完全就是写死的，ddcodes里面的value和label也是写死的 */
    const payMethodsList = this.ddCodes.PAYMENT_METHOD;
    let otherPayTypeVal = otherPayType;
    if (onlinePayType === "0") {
      otherPayTypeVal = payMethodsList.map(({ value }) => value);
    }
    if (onlinePayType === "1") {
      otherPayTypeVal = payMethodsList
        .filter(({ value }) => value !== "线下支付")
        .map(({ value }) => value);
    }
    this.form.otherPayType = otherPayTypeVal;
    // 这里有个支付方式，和之前的可能会有冲突，这里只是赋值
    const { cycleTime } = this.cycleForm;
    const timeExpressionStr =
      acFrequency === "1" ? this.cycleExpresstion || "1-1-1" : "1-1-1";
    const requestData = {
      orgCode: this.currentOrgCode,
      activityName: acName, // 活动名称
      activityBegin: acTimedate[0],
      activityEnd: acTimedate[1],
      isCycleActivity: acFrequency === "1",
      timeExpression: timeExpressionStr, // 转换每周每月的表达式
      activitytimeBegin:
        acFrequency === "1" ? cycleTime[0] || `10:00:00` : "10:00:00", // 默认时间在定义时也有
      activitytimeEnd:
        acFrequency === "1" ? cycleTime[1] || `23:59:59` : "23:59:59",
      isPremium: !!parseInt(acIsPremium), // 默认是false
      premiumRangStart: !isNaN(parseInt(acIsPremium)) ? acPriceBottom : "",
      premiumRangEnd: !isNaN(parseInt(acIsPremium)) ? acPriceTop : "",
      qualificationsExpression: JSON.stringify(
        this.fActivityExpresstion() || "",
      ),
      preheatTime: parseInt(preTime), // 预热时间
      coolingTime: parseInt(coolTime), // 冷却时间
      backgroundImage, // 背景图片
      entranceImage, // 入口图片
      displayName, // 显示名称
      activityLabel, // 标签
      activityRemark: memo, // 简述
      activityDescribe: desc, // 描述
      activityType: this.routeType, // 创建的类型
      qualificationInputs: this.fOtherExpression(), // 其他条件
      paymentMethod: !this.isEmptyArr(otherPayTypeVal)
        ? String(otherPayTypeVal)
        : "",
      activitySkuInput: this.fActivitySkuList(), // 选中的商品
    };
    return requestData;
  }
  fRules(props, message = "必填") {
    const commonRule = [
      {
        required: true,
        message,
        trigger: "blur",
      },
    ];
    let rulesObj = {};
    for (let item of props) {
      rulesObj[item] = commonRule;
    }
    return rulesObj;
  }
  fActivityExpresstion() {
    // tag 其中一个维度，可能有多个维度
    // { tag: Array<String[value]> }
    const rangType = this.form.acRange;
    let tagVals;
    tagVals = this.form.acTagSearch;
    if (parseInt(rangType) === 0) {
      // tagVals = this.setAllTags();
      // return {
      //   tag: tagVals,
      //   storeCode: []
      // };
      tagVals = { type: "0" };
    }
    if (parseInt(rangType) === 1) {
      tagVals = { ...tagVals };
    }
    if (parseInt(rangType) === 2) {
      // acTagSearch 是array<obejct>
      const type = this.formAcRangeType === "0" ? "3" : "4";
      if (type === "4") {
        tagVals = tagVals
          .map(({ 门店编码 }) => String(门店编码 || ""))
          .filter(Boolean);
      }
      tagVals = {
        type,
        storeCode: tagVals,
      };
    }
    return tagVals;
  }
  getActivityLabel(val) {
    const obj = this.tagOptions.find(({ value }) => val == value);
    const label = obj && obj.label;
    return label || val || "";
  }
  dfActivityExpresstion(jsonStr, cb?: Function) {
    try {
      let { type = "1", storeCode = [], ...tagItems } = JSON.parse(jsonStr);
      let vals = {};
      type = parseInt(type);
      if (type === 0) {
        vals = {
          type: "0",
        };
      }
      if ([1, 2].includes(type)) {
        vals = {
          type: String(type),
          ...tagItems,
        };
      }
      // 按门店的手动选择
      if (type === 3) {
        vals = storeCode;
      }
      // 按门店的文件导入
      if (type === 4) {
        vals = storeCode;
      }
      if (typeof cb === "function") {
        cb(type);
      }
      return vals;
    } catch (error) {
      return {
        type: "0",
      };
    }
  }
  handleStoreSelect(list) {
    this.form.acTagSearch = this.formAcTagSearch;
  }
  activityExpresstionType(jsonStr) {
    // 传回的数据有tag
    try {
      let { tag = [], storeCode = [], type = "0" } = JSON.parse(jsonStr);
      // 判断是否是选中了所有
      if (String(type) === "2") {
        type = "1";
      }
      if (["3", "4"].includes(String(type))) {
        type = "2";
      }
      return String(type);
    } catch (error) {
      return "0";
    }
  }
  fActivitySkuList() {
    const fMoney = (price) => {
      const num = parseFloat(price).toFixed(2);
      return Number(num) === 0 ? num : isNaN(Number(num)) ? null : num;
    };
    const { currentOrgCode } = this;
    const data = this.form.skuList.map(
      ({
        salePrice, // 活动价
        productPrice, // 开票价
        orgCode,
        skuCode,
        productCode,
        skuName,
        skuQuota, // 总库存: 剩余库存skuInventory传到总库存
        skuInventory, // 剩余库存
        eachPerUser, // 单次限购
        maxPerUser, // 累计限购
        initUser, // 起购量
        activityCode,
        mediaLink,
      }) => ({
        salePrice: fMoney(salePrice),
        productPrice: fMoney(productPrice),
        orgCode: orgCode || currentOrgCode,
        skuCode: productCode ? productCode : "", // 3.2.0 之后的版本没有skuCode 直接skuCode用productCode
        productCode,
        skuQuota: fMoney(skuInventory),
        eachPerUser: fMoney(eachPerUser),
        maxPerUser: fMoney(maxPerUser),
        initUser: fMoney(initUser),
        activityCode,
        skuName,
        mediaLink,
      }),
    );
    return data;
  }

  tableRowDelete(tid) {
    this.form.skuList.splice(tid, 1);
  }

  async getDics() {
    Promise.all([
      this.getTagOptions(),
      this.getTemplateUrl(),
      this.$dd.register(["PAYMENT_METHOD"]).query(),
      this.getDic(),
    ]);
  }

  /**
   * 页面内逻辑
   */
  handleAddProduct() {
    // 添加商品 活动日期和门店标签已选的情况下，才可以添加商品。
    this.selectProductVisible = true;
  }

  fProgress(row) {
    const boughtNum = row.consumeInventory || 0; // 已购库存
    const skuNum = row.skuInventory || 0; // 剩余库存
    const division = boughtNum / (skuNum + boughtNum);
    const progress = (
      parseFloat((isNaN(division) ? 0 : division).toFixed(2)) * 100
    ).toFixed(2);
    return !boughtNum && !skuNum ? "-" : progress + "%";
  }

  fDateLine(date) {
    if (!date) return null;
    let d = String(date);
    const isValid = /-/g.test(d);
    if (isValid) {
      return d;
    }
    d = d.replace(/\./g, "-");
    return d;
  }
  validIntNum = (rule, value, callback) => {
    const isValid = /^(([1-9]\d*)|\d)(\.\d{1,2})?$/.test(String(value));
    const { changePriceStr } = this;
    if (Number(value) > 999999999) {
      callback(new Error(changePriceStr));
    } else if (isValid) {
      callback();
    } else {
      callback(new Error(changePriceStr));
    }
  };
  validTagSearch = (rule, value, callback) => {
    let needValid = true;
    if (value) {
      try {
        const objVals = Object.values(value);
        if (objVals.length > 1) {
          needValid = objVals.some(
            (item) => Array.isArray(item) && item.length === 0,
          );
        }
      } catch (error) {
        needValid = false;
      }
    }
    if (needValid) {
      callback(new Error("请选择标签"));
    } else {
      callback();
    }
  };
  disabledFn(data, node) {
    return typeof data.orgType !== "number";
  }
  setAllTags() {
    const allTags = this.tagOptions.map(({ value }) => value);
    // this.form.acTagSearch = allTags;
    return allTags;
  }
  fOtherExpression() {
    const { otherSaleChannel, otherPayType } = this.form;
    let tmp = [];
    const valObj = (code, valStr) => ({
      qualificationCode: code,
      qualificationValue: String(valStr),
    });
    if (!this.isEmptyArr(otherSaleChannel)) {
      tmp.push(valObj(this.ddCodeChannel, otherSaleChannel));
    }
    if (!this.isEmptyArr(otherPayType)) {
      tmp.push(valObj(this.ddCodePayment, otherPayType));
    }
    return tmp;
  }
  dfOtherExpression(ddCode, expressions) {
    const obj = expressions.find(
      ({ qualificationCode }) => qualificationCode === ddCode,
    );
    const vals = (obj && obj.qualificationValue) || "";
    return vals && vals.split(",");
  }
  fConditionListFn(searchVal) {
    return [
      { key: "productName,productCode", value: searchVal, type: 4 },
      { key: "status", value: 1, type: 0 },
    ];
  }
  isOaCooperation: any = "";
  memberType: any = "";
  marketType: any = "";
  showFinanceInfo: any = false;

  @loadingCatch
  async created() {
    this.memberType = localStorage.getItem("memberType");
    this.marketType = localStorage.getItem("marketType");

    this.isOaCooperation = localStorage.getItem("isOaCooperation");
    // 获取字典需要在前
    this.loading = true;
    await this.getDics();
    await this.getPageStatusData();
    this.loading = false;

    // await this.queryOrganizationByLevel3Api();
  }
  isEmptyArr(arr) {
    if (Array.isArray(arr)) {
      return !arr.length;
    }
    return false;
  }
  fSingleImg(imgUrl) {
    let lastImg = null;
    if (imgUrl) {
      imgUrl = String(imgUrl);
      let imgUrlList = imgUrl.split(",");
      lastImg = imgUrlList.shift();
    }
    return lastImg || defaultImgPlaceholder;
  }
  hasShowRange(pageStatus, rangeVal) {
    const {
      routerPageStatus,
      form: { acRange },
    } = this;
    const N = Number;
    return (
      (N(routerPageStatus) == N(pageStatus) && N(acRange) == N(rangeVal)) ||
      N(routerPageStatus) != N(pageStatus)
    );
  }
  hasShowBlock(pageStatus, currentVal, formVal) {
    const { routerPageStatus } = this;
    const N = Number;
    return (
      (N(routerPageStatus) == N(pageStatus) && N(formVal) == N(currentVal)) ||
      N(routerPageStatus) != N(pageStatus)
    );
  }
  onUploaderChange(val) {
    this.form.acTagSearch = val;
    try {
      (this.$refs.importTagSearchRef as any).clearValidate();
    } catch (error) {
      console.log(error);
    }
  }
  fAcTags(orgCodes) {
    const vals = orgCodes.map((el) => ({
      门店编码: el.门店编码 ? String(el.门店编码) : String(el),
    }));
    return vals;
  }
  backRouteFn() {
    this.goRoutePage();
  }
  fSkuList(skuList) {
    skuList =
      skuList &&
      skuList.map(
        ({
          productCode = "",
          productName = "",
          salePrice = "",
          productPrice = "",
          orgCode = "default",
          orgName = "default",
          skuCode = "",
          skuName = "",
        }) => {
          let obj = {
            productCode: productCode || skuCode,
            productName: productName || skuName,
            salePrice,
            productPrice,
            orgCode,
            orgName,
            skus: [
              {
                skuCode,
                skuName,
              },
            ],
          };
          return obj;
        },
      );
    return skuList;
  }
  fPickerData(selectedList) {
    selectedList = selectedList.map(({ skus = [], ...item }) => {
      const skusth = (key) => (skus && skus.length > 0 ? skus[0][key] : []);
      return {
        skuCode: skusth("skuCode"),
        skuName: skusth("skuName"),
        ...item,
      };
    });
    return selectedList;
  }
  handleSelectedData(row, column, cell, event) {
    // selected by spu 第一列 点击有效果
    if (column.index === 0) {
      (this.$refs.tableProduct as any).toggleRowSelection(row);
    }
  }
  tableCellClassName({ row, column, rowIndex, columnIndex }) {
    row.index = rowIndex;
    column.index = columnIndex;
  }

  getUniqueNewList(selectedList) {
    const hasExistedList = this.form.skuList.map((el) => el && el.skuCode);
    selectedList = selectedList.filter(
      (el) => !hasExistedList.includes(el && el.skuCode),
    );
    return selectedList;
  }

  async getDic() {
    let res = await this.getDataValue({
      dataCode: "CREDIT_SWITCH",
    });
    if (
      res.dataValue === "1" &&
      this.memberType === "11" &&
      this.marketType === "PCR"
    ) {
      this.showFinanceInfo = true;
    }
    console.log(res, "-----CREDIT_SWITCH");
  }
}
